import { ChatService } from "@/services";
import { CHAT_QUERY_KEYS, CommonParams } from "@/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useGetChatViewers = (
  chatId: number,
  params?: CommonParams<{}>
) => {
  const { error, data, isLoading, isFetching, fetchNextPage, hasNextPage } =
    useInfiniteQuery({
      queryKey: [CHAT_QUERY_KEYS.GET_VIEWER, chatId, params],
      queryFn: ({ pageParam = 1 }) =>
        ChatService.getViewers(chatId, { ...params, page: pageParam }),
      initialPageParam: 1,
      getNextPageParam: (lastPage) => {
        return lastPage.pagination?.hasNextPage
          ? lastPage.pagination.page + 1
          : undefined;
      },
      retry: 1,
      refetchOnMount: true, // Refetch khi component mount
      refetchOnWindowFocus: false, // Không refetch khi focus window
    });

  if (error) throw error;

  const viewers = useMemo(() => {
    return (
      data?.pages
        .flatMap((page) => page.data)
        .map((viewer) => ({
          label: viewer.user_name,
          value: viewer.user_id,
        })) || []
    );
  }, [data]);

  return {
    viewers,
    isLoadingViewers: isLoading || isFetching,
    fetchNextPageViewers: fetchNextPage,
    hasNextPageViewers: hasNextPage,
  };
};
